import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Shell breadcrumb — Home + current page label from nav.
 */
const BreadcrumbBar = memo(function BreadcrumbBar({
  items = [],
  homeLabel = 'Home',
  homePath = '/',
  className = '',
  dir,
}) {
  if (!items.length) return null;

  return (
    <nav
      className={`ads-breadcrumb shell-breadcrumb ${className}`.trim()}
      aria-label="Breadcrumb"
      dir={dir}
    >
      <ol className="ads-breadcrumb__list">
        <li className="ads-breadcrumb__item">
          <Link to={homePath} className="ads-breadcrumb__link ads-breadcrumb__link--home ads-type-micro">
            <Home size={14} strokeWidth={1.75} aria-hidden />
            <span>{homeLabel}</span>
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.path || item.label}-${index}`} className="ads-breadcrumb__item">
              <ChevronRight size={14} className="ads-breadcrumb__sep" aria-hidden />
              {isLast || !item.path ? (
                <span className="ads-breadcrumb__current ads-type-micro" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link to={item.path} className="ads-breadcrumb__link ads-type-micro">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
});

export default BreadcrumbBar;
